export const userActionType = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  TOAST: "TOAST",
  UPDATE_PASSENGERS: "UPDATE_PASSENGERS",
  BOOKING_ID: "BOOKING_ID",
  CANCEL_BOOKING: "CANCEL_BOOKING",
};
